import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './signup.css';

const RecruiterSignup = () => {
    const [formData, setFormData] = useState({
        emailOrPhone: '',
        password: '',
        name: ''
    });
    const [error, setError] = useState('');

    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/authRecruiter/signup', formData);
            // console.log(response.data);
            navigate('/recruiter/verify', { state: { emailOrPhone: formData.emailOrPhone } });
        } catch (error) {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
            } else {
                setError('An error occurred. Please try again.');
            }
            console.error(error);
        }
    };

    return (
        <div className="signup-container">
            <form onSubmit={handleSubmit}>
                <h2>Signup as Recruiter</h2>
                <input
                    type="text"
                    name="emailOrPhone"
                    placeholder="Email or Phone"
                    value={formData.emailOrPhone}
                    onChange={handleChange}
                    required
                />
                <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                />
                <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                />
                {error && <p className="error">{error}</p>}
                <button type="submit">Signup</button>
                <p>Already have an account? <a href="/recruiter/login">Login</a></p>

            </form>
        </div>
    );
};

export default RecruiterSignup;